import { Stack } from '@mui/material';
import LinkCategoryButton from './LinkCategoryButton';
import { getRouterPathToContentIndex } from '../../../utilities/Links';

function getCategoryObject(category: string) {
  return {
    name: category,
    path: getRouterPathToContentIndex(category),
  };
}

interface RelatedCategoriesProps {
  readonly categories: string[];
}

export default function RelatedCategories({
  categories,
}: RelatedCategoriesProps) {
  const categoryObjects = categories.map((category) =>
    getCategoryObject(category),
  );

  return (
    <Stack
      direction='row'
      useFlexGap
      sx={{
        gap: 3,
      }}
    >
      {categoryObjects.map((category) => {
        return (
          <LinkCategoryButton
            key={category.name}
            category={category}
            variant='outlined'
          />
        );
      })}
    </Stack>
  );
}
